var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-number-input"},[_c('button',{staticClass:"increment-btn",on:{"click":_vm.decrement}},[_vm._v("-")]),_c('input',{staticClass:"cantidad-input",attrs:{"type":"text"},domProps:{"value":_vm.displayValue},on:{"input":_vm.onInput}}),_c('button',{staticClass:"increment-btn",on:{"click":_vm.increment}},[_vm._v("+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }